<template>
  <transition name="fade">
    <div
      v-show="$store.state.show === 'page5'"
      :class="['page page5', $store.state.show === 'page5' ? 'active' : '']"
    >
      <div class="content">
        <div class="cont">
          <img src="./images/p5-p1-chuan.png" alt="" class="p1-chuan abs opacity" />
          <div :class="['screen screen1', $store.state.screen === 'screen10' ? 'active' : '' ? 'active' : '']">
            <img src="./images/p5-p1-diaoxiang.png" alt="" class="p1-diaoxiang abs opacity" />
          </div>
          <img src="./images/p5-p1-molihua.png" alt="" class="p1-molihua abs" />
          <div :class="['screen screen2', $store.state.screen === 'screen11' ? 'active' : '' ? 'active' : '']">
            <img src="./images/p5-p2-diaoxiang.png" alt="" class="p2-diaoxiang abs opacity" />
          </div>
        </div>
        <img src="./images/yun-zuo.png" alt="" class="yun-zuo abs" />
        <img src="./images/yun-you.png" alt="" class="yun-you abs" />   
        <img :class="['tips-up abs']" src="./images/tips-up.png" alt="" />
      </div>
    </div>
  </transition>
</template>

<script>
import $ from "jquery";
export default {
  name: "page5",
  components: {},
  data() {
    return {};
  },
  methods: {
    // 下一页
    nextPage() {
      this.$store.dispatch("setPageFn", "page5");
    },
  },
  mounted() {
  },
  watch: {
    "$store.state.show"() {
      // 你需要执行的代码
      if (this.$store.state.show === "page5") {
        // this.pageOperate();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/mixin";

.page5 {
  background: url("./images/p5-p1-bg.jpg") top center no-repeat;
  background-size: 100% auto;

  .screen1 {
    z-index: 13;
  }

  &.active {
    .p1-chuan  {
      -webkit-animation: identifierxl 0.6s ease-out 0.2s;
      animation: identifierxl 0.6s ease-out 0.2s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
  }

  .screen1.active {
    .p1-diaoxiang {
      -webkit-animation: identifieryu 0.6s ease-out 0.2s;
      animation: identifieryu 0.6s ease-out 0.2s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
  }

  .screen2.active {
    .p2-diaoxiang {
      -webkit-animation: identifieryu 0.6s ease-out 0.2s;
      animation: identifieryu 0.6s ease-out 0.2s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
  }

  .content {
    .p1-diaoxiang {
      top: 816px;
      right: 64px;
      width: 481px;
      z-index: 13;
    }

    .p1-chuan {
      top: 846px;
      left: 0;
      width: 517px;
    }

    .p1-molihua {
      width: 100%;
      bottom: 0;
      left: 0;
      z-index: 10;
    }

    .p2-diaoxiang {
      top: 300px;
      left: 94px;
      width: 602px;
    }

  }
}
</style>
